<template>
  <PageTemplate>
    <div class="d-flex justify-content-between">
      <h6 class="element-header">
        {{ $t('travel_expenses.title') }}
      </h6>
    </div>
  </PageTemplate>
</template>

<script setup>
import PageTemplate from '@/components/PageTemplate.vue';
</script>

<style scoped>

</style>